import React, { useEffect, useState } from 'react'
import { getActiveViewUserAll, getGuestAll, getMobileCodeAll } from '../api/usersAPI';
import swal from 'sweetalert2';
import Select from 'react-select';
import AddGuest from '../teeTime/addGuest';
import { updateCaddyTag } from '../api/caddyAPI';

const TagCaddyModal = (props) => {

    const [type,                setType]                = useState('Member')
    const [userList,            setUsersList]           = useState([]);
    const [selectedUser,        setSelectedUser]        = useState(null);
    const [showAddGuest,        setShowAddGuest]        = useState(false);
    const [mobileCodeList,      setMobileCodeList]      = useState([]);

    useEffect(() => {
        $('#tag-caddy-modal').modal({ backdrop: 'static' });

        $('#tag-caddy-modal').on('hidden.bs.modal', function () {
            props.onDismissModal(); 
        });

        $('#tag-caddy-modal').modal('toggle');
    }, [props.show]);

    useEffect(() => {
        fetchUserByType(type)
    }, [type])

    useEffect(() => {
        if (props.caddyQueue.TagType)
            setType(props.caddyQueue.TagType)
        if (userList.length > 0) {
            const player = userList.find(u => u.ID == props.caddyQueue.TagID);
            setSelectedUser(player)
        }
    }, [userList, props.caddyQueue])

    const fetchUserByType = async () => {
        try {
            if (type == 'Member') {
                const users = await getActiveViewUserAll();
                setUsersList(users)
            } else {
                const guests =  await getGuestAll();
                const mobileCodeArr = await getMobileCodeAll()
                setMobileCodeList(mobileCodeArr); 
                setUsersList(guests)
            }
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const AddUserHandler = async (e) => {
        e.preventDefault()
        var form = $('#add-tag-form');
        form.validate({
            rules: {
                ddlUser: {
                    required: true
                }, 
            },
            messages: {
                ddlUser: {
                    required: "Please select user",
                },
            }
        });

        if (!form.valid()) return;
        try {
            await updateCaddyTag(props.show, type, selectedUser.ID, selectedUser.Name);
            props.fetchCaddyQueue()
            $("#tag-caddy-modal").modal("hide");
        } catch (err) {
            swal.fire({
                icon                : 'error',
                titleText           : 'Error!',
                text                : err.message,
                buttonsStyling      : false,
                confirmButtonClass  : 'btn btn-brand',
            }); 
        }
    }

    return (
        <>
            <div className="modal fade" id="tag-caddy-modal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"> Tag Caddy </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"> </button>
                        </div>
                        <form id='add-tag-form'>
                            <div className="modal-body">
                                <div className="modal-body padding-25 padding-b0">
                                    <div id="tag-modal-holder" className="kt-form kt-form--label-right padding-10" role="form">
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3">Type</label>
                                            <div className="col-xl-6 col-lg-8">
                                                <select
                                                    className="form-control kt-selectpicker"
                                                    id="ddlBannerType"
                                                    value={type}
                                                    onChange={(event) => setType(event.target.value)}>                                                 
                                                    <option value="Member">Member</option>
                                                    <option value="Guest">Guest</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3">{type == 'Member' ? 'Member' : 'Guest'}</label>
                                            <div className="col-xl-6 col-lg-6">
                                                <Select 
                                                    id="ddlUser" 
                                                    name="ddlUser"
                                                    className="multi-custom multi__control"
                                                    placeholder="Select User"
                                                    value={selectedUser && {label: selectedUser.Name, value: selectedUser}}
                                                    onChange={(e) => setSelectedUser(e.value)}
                                                    options={userList.map(c => ({
                                                        label: `${c.Name} (${type == 'Member' ? c.MembershipNo : c.Mobile})`,
                                                        value: c
                                                    }))}
                                                />
                                            </div>
                                            {type == 'Guest' &&(<div className="col-xl-3 col-lg-3 vertical-center justify-content-start">
                                                <button id="btnAddGuest" type="button" className="btn btn-primary btn-sm margin-0 " data-toggle="modal" data-target="#modalGuest" onClick={() => setShowAddGuest(true)} >New Guest </button>
                                            </div>)}
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer padding-tb10">
                                    <button type="button" data-dismiss="modal" className="btn btn-secondary margin-0 margin-r5 " id="btn_close">Close </button>
                                    <button type="button" className="btn btn-brand margin-0 " id="btnCaddySave" onClick={AddUserHandler}>Add </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {showAddGuest && (
                <AddGuest
                    show={showAddGuest}
                    onDismissModal={setShowAddGuest}
                    mobileCodeList={mobileCodeList}
                    fetchGuest={() => fetchUserByType()}
                    from='mat'
                    // bookingUserList={bookingUserList}
                />
            )}
        </>
    )
}

export default TagCaddyModal